import { render, staticRenderFns } from "./CDropdownMenu.vue?vue&type=template&id=574e4404&scoped=true&"
import script from "./CDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./CDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./CDropdownMenu.vue?vue&type=style&index=0&id=574e4404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e4404",
  null
  
)

export default component.exports